exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invite[data-v-56f80545]{padding:20px}\n", ""]);

// exports
